import { ICompanyGroup } from "bets.oddprovider.lib.common.ts/models"
import { NumberUtils } from "fwork-jsts-common/src"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import React, { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { DEFAULTGAP, RoutesNames } from "../../globals"
import { ICompaniesGroupsState, companiesGroupsStateLoadFromApi } from "../../redux/reducers/companiesGroups.slice"
import { toggleLoading } from "../../redux/reducers/loadingBar.slice"
import { RootState } from "../../redux/store"
import { HeaderComponent } from "../common/header"
import { SearchInputComponent } from "../common/searchInput"

export const CompaniesGroupsComponent = () => {
  const tableComponentSetCurrPageRef = useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [searchText, setSearchText] = useState<string | undefined>()

  const companiesGroupsState: ICompaniesGroupsState = useSelector((state: RootState) => state.companiesGroupsState)
  const companiesGroups = [...companiesGroupsState.payload || []]

  const loadCompaniesGroups = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<ICompanyGroup> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' }
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(companiesGroupsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Grupos de Empresas'
        onRefreshClick={loadCompaniesGroups}
        onAddClick={() => navigate(RoutesNames.companyGroup)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por nome ou código'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadCompaniesGroups() }}
        onIconClick={loadCompaniesGroups}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={companiesGroups}
        bodyRowBuilder={(companyGroup: ICompanyGroup) => {
          return <StyledTableCell>
            <StyledListItemText
              primary={companyGroup.name}
            />
          </StyledTableCell>
        }}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: ICompanyGroup) => {
            navigate(RoutesNames.companyGroup.replace(':id', item?.id.toString()))
          }
        }}
      />

    </div>
  </>
}